import { Heading } from 'shared/ui/list-page-heading';
import { Box, Divider, Tab, Tabs } from '@mui/material';
import { Link as RouterLink, useLocation, Outlet, Route, Routes } from 'react-router-dom';
import AccountingTab from 'components/Settings/accounting-tab';
import { useTitleHook } from 'hooks/page-title.hook';
import { ContractTemplatesTab } from 'components/Settings/contract-templates-tab';
import MediaTypesList from './media-types-list';
import { OurLegalEntitiesList } from 'entities/legal-entities/our-legal-entities/our-legal-entities-list';
import OwnerShipList from './form-of-ownership-list';
import { UsersRolesList } from '../../entities/user/user-roles/user-roles';
import EmailParserList from './email-parser-list';
import EmailSpamList from './email-spam-list';
import { SalesDepartmentsList } from '../../entities/sales-departments/sales-departments-list';
import { RemoteAccessList } from 'features/user/remote-access';
import { CommonSettingsTab } from './common';
import OkvedList from './okved-list';
import { FilesList } from './files-list';
import { SettingsTags } from './tags';
import { ServiceFunctionsSettingsTab } from './service-functions';

const titleMap: Record<string, string> = {
  'accounting': 'Расчетные счета',
  'contract-templates': 'Шаблоны договоров',
  'media-types': 'Настройки СМИ',
  'our-legal-entities': 'Наши юр. лица',
  'form-of-ownership': 'Формы собственности',
  'okved': 'Род деятельности',
  'files': 'Файлы',
  'email-parser': 'Настройки почты',
  'email-spam': 'Настройки почты',
  'user-roles': 'Роли пользователей',
  'sales-departments': 'Отделы продаж',
  'remote-access': 'Удаленный доступ',
  'home': 'Доверенные IP-адреса',
  'tags': 'Тэги',
  'service-functions': 'Сервисные функции',
};

const SettingsPage = () => {
  const location = useLocation();

  const currentPath = location.pathname.split('/').pop() || 'home';
  const title = titleMap[currentPath] || 'Настройки';

  useTitleHook(title);
  return (
    <>
      <Heading title={title} />

      {(currentPath === 'email-parser' || currentPath === 'email-spam') && (
        <Box>
          <Tabs value={currentPath}>
            <Tab value="email-parser" label="Почтовые ящики" component={RouterLink} to="/settings/email-parser" />
            <Tab value="email-spam" label="Spam" component={RouterLink} to="/settings/email-spam" />
          </Tabs>
          <Divider />
        </Box>
      )}

      <Routes>
        <Route element={<Outlet />}>
          <Route path="home" element={<CommonSettingsTab />} />
          <Route path="accounting" element={<AccountingTab />} />
          <Route path="contract-templates" element={<ContractTemplatesTab />} />
          <Route path="media-types" element={<MediaTypesList />} />
          <Route path="our-legal-entities" element={<OurLegalEntitiesList />} />
          <Route path="form-of-ownership" element={<OwnerShipList />} />
          <Route path="okved" element={<OkvedList />} />
          <Route path="email-parser" element={<EmailParserList />} />
          <Route path="email-spam" element={<EmailSpamList />} />
          <Route path="user-roles" element={<UsersRolesList />} />
          <Route path="sales-departments" element={<SalesDepartmentsList />} />
          <Route path="remote-access" element={<RemoteAccessList />} />
          <Route path="files" element={<FilesList />} />
          <Route path="tags" element={<SettingsTags />} />
          <Route path="service-functions" element={<ServiceFunctionsSettingsTab />} />
        </Route>
      </Routes>
    </>
  );
};

export default SettingsPage;
